import { useEffect, useState } from "react";
import TableAHSF from "../../../Components/TableAHSF";
import AddEdit_Objectives from "./AddEdit_Objectives";
import PopupAHSF from "../../../Components/PopupAHSF";
import { setRefreshTable } from "../../../Redux/Reducers/VariousVariables";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteObjectivesById,
  GetObjectivesById,
} from "../../../Redux/Reducers/BudgetInformation/Objectives";
import { useParams } from "react-router-dom";

import Swal from "sweetalert2";
import { decryptToken } from "../../../Services/Account/EncryptionParams";
const Objectives = () => {
  const AppGuid = useParams();
  const lodingAddObjectives = useSelector(
    (state) => state.objectives.loadingAddBI_TimelineInformation
  );
  const lodingEditObjectives = useSelector(
    (state) => state.objectives.loadingEditObjectives
  );
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  const lodingObjectives = useSelector(
    (state) => state.objectives.loadingDeleteObjectives
  );
  const [PopupComponentViewStatus, setPopupComponentViewStatus] =
    useState(false);
  const [PopupComponentEditStatus, setPopupComponentEditStatus] =
    useState(false);
  const [bI_ObjectivesId, setbI_ObjectivesId] = useState("");

  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},

    componentBody: <AddEdit_Objectives />,
    maxWidth: "500px",

    maxHeight: "800px",
    title: "الأهداف",
  };
  const RequestAccessor = [
    {
      KeyName: "objectiveName",
      ShowStatus: true,
      NmaeColumn: "الهدف",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "schumannsContribution",
      ShowStatus: true,
      NmaeColumn: "مساهمة شومان",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
  ];
  const OtherMainBtns = [
    {
      Click: async (e) => {
        //console.log(e, "sldsdsd");
        setbI_ObjectivesId(e.target.value);
        closePopupEditComponent();
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "عرض",
      ShowStatus: !shouldDisableFields,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then((res) => {
          if (res.isConfirmed == true) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            //delete ow from table by id after confirmed
            dispatch(DeleteObjectivesById({ bI_ObjectivesId: e.target.value }));
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      ShowStatus: !shouldDisableFields,
    },
    {
      Click: async (e) => {
        //console.log(e.target.value, "sldsdsd");
        setbI_ObjectivesId(e.target.value);
        closePopupViewComponent();
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: shouldDisableFields,
    },
  ];
  const closePopupViewComponent = () => {
    if (PopupComponentViewStatus) {
      setPopupComponentViewStatus(false);
    } else {
      setPopupComponentViewStatus(true);
    }
  };

  const closePopupEditComponent = () => {
    if (PopupComponentEditStatus) {
      setPopupComponentEditStatus(false);
    } else {
      setPopupComponentEditStatus(true);
    }
  };
  //to refresh table on any action
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [lodingObjectives, lodingAddObjectives, lodingEditObjectives]);

  const RequestsColumns = [];
  //to render html after get data
  return (state.ApplicationInformation && state.ActiveRound) ||
    decryptToken(AppGuid.AppGuid) ? (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"bI_ObjectivesId"}
        valueButtonAction={"bI_ObjectivesId"}
        URL={`api/Objectives/GetObjectivesListByAppGuid`}
        UrlBody={{
          aI_ApplicationInformationId:
            localStorage.getItem("aI_ApplicationInformationId") ||
            decryptToken(AppGuid.AppGuid),
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الأهداف"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!shouldDisableFields}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        // popUpBody2={[<ShowApplication addFun={true} />]}
        // popUpId2={"ShowApplicationpopUp"}
        // popUpBody2={[
        //   <ShowApplication columnId={columnId} list={list} addFun={false} />,
        // ]}
        // handleCloseModal={handleCloseModal}
        // showModal={showPopUp}
      />
      <PopupAHSF
        title={"الأهداف"}
        componentBody={
          <AddEdit_Objectives
            ViewData={true}
            disabledData={true}
            Action={"view"}
            bI_ObjectivesId={bI_ObjectivesId}
          />
        }
        maxWidth="500px"
        maxHeight="800px"
        isPopupOpenStatus={PopupComponentViewStatus}
        isPopupOpenFunction={closePopupViewComponent}
      />

      <PopupAHSF
        title={"الأهداف"}
        componentBody={
          <AddEdit_Objectives
            ViewData={true}
            disabledData={false}
            Action={"edit"}
            bI_ObjectivesId={bI_ObjectivesId}
          />
        }
        maxWidth="500px"
        maxHeight="800px"
        isPopupOpenStatus={PopupComponentEditStatus}
        isPopupOpenFunction={closePopupEditComponent}
      />
    </>
  ) : (
    ""
  );
};
export default Objectives;
